import React from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { AvatarWrapper } from "../home/user-profile";
import { assetIcons } from "../../../constants/assets"; // Importing static asset
import { darkColors } from "../../../theme/colors";
import InlineSvg from "../inline-svg";
import { useUser } from "../../../context/user-context";

const UserDetails = ({ userBetInfo }) => {
  const { user } = useUser();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
      <AvatarWrapper>
        <Avatar
          src={user?.imageURL}
          // alt="loading..."
          sx={{
            width: 57,
            height: 57,
            border: "2px solid",
            borderColor: darkColors.buttonTop, // Static border color
          }}
        />
      </AvatarWrapper>
      <Box>
        <Typography
          sx={{
            color: "white",
            fontSize: "16px",
            fontWeight: 700,
          }}
        >
          {user.username}
        </Typography>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <InlineSvg sx={{ mt: 0.7 }} url={assetIcons.currencyIcon} />
          <Typography sx={{ color: "white", textAlign: "left" }}>
            {user.walletAmount}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default UserDetails;
